import { WidgetTile } from 'components/widgets/tile/tile';
import styled from 'styled-components';

export const StyledRepairPartnerWidgetTile = styled(WidgetTile)`
  min-height: auto;
  margin-bottom: 10px;
`;
